import type { Provider } from '../types/provider';

export const providers: Provider[] = [
  {
    slug: 'pragmatic-play', name: 'Pragmatic Play', founded: 2015, headquarters: 'Sliema, Malta',
    licenses: 'MGA, UKGC, Ksa', signature: 'Pay Anywhere met tumble en multipliers', color: '#C2410C',
    intro: 'Pragmatic Play is de meest aanwezige provider in onze Top 30. De studio brengt bijna elke week een nieuwe slot uit en heeft met Gates of Olympus en Sweet Bonanza twee van de meest gespeelde slots ter wereld.',
    nzNote: 'In Nieuw-Zeeland staan Gates of Olympus, Sweet Bonanza en de Big Bass-reeks structureel bovenaan de pokies-ranglijsten.',
    nlNote: 'Op de Nederlandse markt heeft Pragmatic Play het grootste aandeel in de casinolobby’s van alle providers.',
    strengths: ['Hoge RTP-standaard rond 96,5%', 'Sterke bonus buy- en ante bet-opties', 'Consistente mobiele kwaliteit'],
  },
  {
    slug: 'play-n-go', name: "Play'n GO", founded: 1997, headquarters: 'Växjö, Zweden',
    licenses: 'MGA, UKGC, Ksa', signature: 'Uitbreidende symbolen en cascades', color: '#1F5C45',
    intro: 'De Zweedse veteraan achter Book of Dead. Play’n GO combineert eenvoudige, herkenbare mechanieken met sterke thema’s en een enorme catalogus.',
    nzNote: 'Book of Dead wordt in meerdere Nieuw-Zeelandse ranglijsten als de favoriete slot van Kiwi-spelers genoemd.',
    nlNote: 'Book of Dead en Legacy of Dead behoren tot de meest gespeelde slots in Nederlandse online casino’s.',
    strengths: ['Tijdloze, makkelijk te leren mechanieken', 'Sterk Egypte-genre', 'Breed aanwezig in NZ-casino’s'],
  },
  {
    slug: 'netent', name: 'NetEnt', founded: 1996, headquarters: 'Stockholm, Zweden',
    licenses: 'MGA, UKGC, Ksa', signature: 'Avalanche en sticky wilds', color: '#2A3F8F',
    intro: 'NetEnt, sinds 2020 onderdeel van Evolution, schreef slotgeschiedenis met Starburst en Gonzo’s Quest. De klassiekers blijven tot op vandaag in de toplijsten staan.',
    nzNote: 'Starburst is in Nieuw-Zeeland een van de meest aangeboden welkomstbonus-slots.',
    nlNote: 'Nederlandse spelers kennen NetEnt vooral van Starburst en de Dead or Alive-reeks.',
    strengths: ['Iconische klassiekers', 'Uitstekend voor lage inzetten', 'Hoge RTP bij Dead or Alive 2'],
  },
  {
    slug: 'elk-studios', name: 'ELK Studios', founded: 2012, headquarters: 'Stockholm, Zweden',
    licenses: 'MGA, UKGC, Ksa', signature: 'Uitbreidende speelvelden met verzamelmechaniek', color: '#2E7D6B',
    intro: 'ELK Studios brengt weinig slots uit, maar elke release is uitgebreid doordacht. De Pirots-reeks is het bewijs dat originaliteit nog steeds loont.',
    nzNote: 'Pirots 4 groeit snel in Nieuw-Zeeland, vooral bij spelers die iets anders zoeken dan Pragmatic.',
    nlNote: 'In Nederland laat Pirots 4 in 2026 een van de sterkste stijgingen in zoekinteresse zien.',
    strengths: ['Zeer originele mechanieken', 'Hoge productiekwaliteit', 'Variabele inzetstrategieën (X-iter)'],
  },
  {
    slug: 'hacksaw-gaming', name: 'Hacksaw Gaming', founded: 2018, headquarters: 'Sliema, Malta',
    licenses: 'MGA, UKGC', signature: 'Hoge volatiliteit en meerdere bonusmodi', color: '#8C3B24',
    intro: 'Hacksaw Gaming staat voor brutale cartoonstijl en extreme winpotentie. Bijna elke slot heeft meerdere bonusrondes die je los kunt kopen.',
    nzNote: 'Wanted Dead or a Wild en Le Bandit worden in Nieuw-Zeeland vooral door streamers populair gemaakt.',
    nlNote: 'Bij Nederlandse spelers groeit Hacksaw snel, vooral in de categorie high-volatility.',
    strengths: ['Maximale winsten tot 25.000x+', 'Herkenbare visuele stijl', 'Meerdere bonusmodi per slot'],
  },
  {
    slug: 'relax-gaming', name: 'Relax Gaming', founded: 2010, headquarters: 'Sliema, Malta',
    licenses: 'MGA, UKGC', signature: 'Respins met persistente symbolen', color: '#2F4858',
    intro: 'Relax Gaming is zowel studio als aggregator. Met de Money Train-reeks heeft de provider een van de meest gevreesde bonusrondes in de branche.',
    nzNote: 'Money Train 4 staat bij Kiwi-spelers bekend om zijn enorme maximale winst.',
    nlNote: 'Relax Gaming is in Nederland vooral bekend via de Money Train-reeks.',
    strengths: ['Extreem winpotentieel', 'Sterke respin-bonussen', 'Kwalitatieve sequels'],
  },
  {
    slug: 'nolimit-city', name: 'Nolimit City', founded: 2014, headquarters: 'Stockholm, Zweden',
    licenses: 'MGA, UKGC', signature: 'xWays, xBomb en andere x-mechanieken', color: '#45474A',
    intro: 'Nolimit City maakt de meest provocerende en volatiele slots op de markt. Technisch indrukwekkend, maar uitsluitend geschikt voor spelers met een strak budget.',
    nzNote: 'Fire in the Hole 3 is in Nieuw-Zeeland een van de best bekeken slots op streamingplatforms.',
    nlNote: 'Nolimit City heeft in Nederland een kleinere maar zeer trouwe spelersgroep.',
    strengths: ['Innovatieve x-mechanieken', 'Maximale winsten tot 70.000x', 'Sterke thematiek'],
  },
  {
    slug: 'big-time-gaming', name: 'Big Time Gaming', founded: 2011, headquarters: 'Sydney, Australië',
    licenses: 'MGA, UKGC', signature: 'Megaways', color: '#6B4E2A',
    intro: 'De Australische uitvinder van Megaways, het systeem met tot 117.649 winmanieren. De mechaniek wordt inmiddels door tientallen andere providers in licentie gebruikt.',
    nzNote: 'Als buurman uit Australië heeft Big Time Gaming een lange geschiedenis in de Nieuw-Zeelandse pokies-cultuur.',
    nlNote: 'Bonanza Megaways is in Nederland nog altijd de bekendste Megaways-slot.',
    strengths: ['Uitvinder van Megaways', 'Onbeperkte multipliers', 'Regionale band met NZ'],
  },
  {
    slug: 'bgaming', name: 'BGaming', founded: 2018, headquarters: 'Limassol, Cyprus',
    licenses: 'MGA, Curaçao', signature: 'Coin respins met jackpots', color: '#1E7A5A',
    intro: 'BGaming maakt luchtige, mobielvriendelijke slots met een eigen humor. Elvis Frog is de mascotte van de studio geworden.',
    nzNote: 'BGaming is populair bij Nieuw-Zeelandse casino’s die zich op mobiele spelers richten.',
    nlNote: 'In Nederland is BGaming minder groot, maar Elvis Frog heeft een vaste plek in veel lobby’s.',
    strengths: ['Sterk op mobiel', 'Toegankelijke volatiliteit', 'Speelse thema’s'],
  },
  {
    slug: 'games-global', name: 'Games Global', founded: 2022, headquarters: 'Douglas, Isle of Man',
    licenses: 'MGA, UKGC', signature: 'Progressieve jackpots', color: '#9A5E16',
    intro: 'Games Global is de opvolger van Microgaming, opgericht in 1994. De catalogus bevat legendarische titels als Mega Moolah en Thunderstruck II.',
    nzNote: 'Mega Moolah is in Nieuw-Zeeland synoniem met recordjackpots.',
    nlNote: 'Nederlandse spelers kennen de catalogus nog grotendeels onder de naam Microgaming.',
    strengths: ['Grootste progressieve jackpots', 'Tijdloze klassiekers', 'Enorme catalogus'],
  },
  {
    slug: 'push-gaming', name: 'Push Gaming', founded: 2010, headquarters: 'Londen, Verenigd Koninkrijk',
    licenses: 'MGA, UKGC', signature: 'Cluster pays met wandelende wilds', color: '#A23A72',
    intro: 'Push Gaming is een kleine Britse studio met een opvallend hoge RTP-standaard. Jammin’ Jars is hun bekendste titel.',
    nzNote: 'Jammin’ Jars wordt in Nieuw-Zeeland vooral gewaardeerd om zijn hoge RTP.',
    nlNote: 'In Nederland is Push Gaming een nichefavoriet bij RTP-bewuste spelers.',
    strengths: ['RTP vaak boven 96,5%', 'Originele cluster-mechanieken', 'Weinig maar sterke releases'],
  },
];
